exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-5891c56c]{list-style-type:none}ul ul[data-v-5891c56c]{list-style-type:disc;margin-left:20px}a[data-v-5891c56c]{color:#0645ad;text-decoration:none}a[data-v-5891c56c]:hover{text-decoration:underline}", ""]);

// exports
